import React, { useEffect } from 'react';
import { Gallery, Testimonials } from '../components/home/GalleryTestimonials';
import { ScheduleCta } from '../components/home/CtaPostsCoupons';
import { Hero } from '../components/home/Hero';

export default function OurWork() {
  useEffect(() => {
    document.title = 'Our Work - Phoenix Roofing & Chimney NJ';
  }, []);
  return (
    <div data-testid="our-work-page">
      <Hero titleWhite="Our" titleRed="Work" kicker="Transformative Roofing Projects" sub="Free Inspections – Same Day Service" />
      <Gallery />
      <Testimonials />
      <ScheduleCta />
    </div>
  );
}
